module.exports = __webpack_public_path__ + "img/adchoices.30760f0f.png";